<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Registro de Resultados de las Inducciones</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Resultados de las Inducciones</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <app-induccion-filtros-busqueda [modelFilter]="modelFilter" [displayFechaAprobacion]="false"
          [displayFechaInduccion]="true"></app-induccion-filtros-busqueda>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <button class="btn btn-naranja" mat-raised-button [disabled]="esInvalido()" (click)="registrarResultados()">
              <mat-icon>description</mat-icon> Registrar Resultados
            </button>
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>

          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="modelListaInducciones" class="table table-striped table-vcenter">
          <ng-container matColumnDef="codigo_solicitud">
            <th mat-header-cell *matHeaderCellDef>Codigo Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.codigoSolicitud }}
            </td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.persona.nombres }} {{ element.persona.apellidoPaterno }}
              {{ element.persona.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro. Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.persona.nroDocumentoIdentidad }}
            </td>
          </ng-container>

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">
              {{ element.contratista }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.sede }}
            </td>
          </ng-container>

          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">
              {{ element.solicitante }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_induccion">
            <th mat-header-cell *matHeaderCellDef>Fecha y hora de Inducción</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaHoraInduccion | date: "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <mat-select matSelect [(ngModel)]="element.idEstado" name="idEstado">
                  <mat-option *ngFor="let item of paramsEstados; index as i;" [value]='item.idParametroDetalle'>{{item.nombre}}</mat-option>
                </mat-select>
  
              </td>
            </ng-container> -->

          <ng-container matColumnDef="aprobado">
            <th mat-header-cell *matHeaderCellDef>Aprobado
              <mat-slide-toggle [(ngModel)]="checkTodosAprobados" (change)="changeAprobadoAll($event)">
              </mat-slide-toggle>
            </th>
            <td mat-cell *matCellDef="let element" class="centre">
              <mat-slide-toggle [(ngModel)]="element.aprobado" (change)="changeAprobado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="desaprobado">
            <th mat-header-cell *matHeaderCellDef>Observado
              <mat-slide-toggle [(ngModel)]="checkTodosObservados" class="observado"
                (change)="changeDesaprobadoAll($event)">
              </mat-slide-toggle>

            </th>
            <td mat-cell *matCellDef="let element">
              <mat-slide-toggle [(ngModel)]="element.desaprobado" class="observado"
                (change)="changeDesaprobado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>


<!-- <pre>{{ modelListaInducciones | json}}</pre> -->